import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { useEffect } from "react";
import { BookOpen, Video, Calendar, FolderOpen, Users, Heart } from "lucide-react";

export default function MembersPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [user, loading, navigate]);

  if (loading || !user) return <div className="min-h-[50vh] flex items-center justify-center text-[#595959]">Loading...</div>;

  const links = [
    { to: "/members/sermons", icon: Video, title: "Sermons", desc: "Watch and listen to sermons" },
    { to: "/members/devotionals", icon: BookOpen, title: "Devotionals", desc: "Daily devotional readings" },
    { to: "/members/events", icon: Calendar, title: "Events", desc: "Upcoming church events" },
    { to: "/members/resources", icon: FolderOpen, title: "Resources", desc: "Guides and downloads" },
    { to: "/members/directory", icon: Users, title: "Member Directory", desc: "Connect with other members" },
  ];

  return (
    <div data-testid="members-page">
      <section className="bg-[#1C2E4A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Members Area</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-white">Welcome, {user.name || "Member"}</h1>
        </div>
      </section>
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {links.map((item) => (
              <Link key={item.to} to={item.to} data-testid={`member-link-${item.title.toLowerCase()}`} className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-6 hover:shadow-md hover:-translate-y-1 transition-all">
                <item.icon className="w-6 h-6 text-[#C8A97E] mb-3" />
                <h3 className="font-serif text-base font-semibold text-[#1C2E4A] mb-1">{item.title}</h3>
                <p className="text-xs text-[#595959]">{item.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
